/* unplugin-vue-components disabled */import { render } from "./Copyright.vue?vue&type=template&id=06f8216c&scoped=true"
const script = {}

import "./Copyright.vue?vue&type=style&index=0&id=06f8216c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06f8216c"]])

export default __exports__